/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerStatementService = {
  /**
   * Get Screen data
   *
   * */
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async getDetailsListData(params) {

    const requestScreenData = {
      url: "api/CustomerStatementRunDetailList",
      filter: params.filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async saveCustomerStatement(payload) {
    var url = "api/Save_CustomerStatementRun";

    return await ApiService.post(url, payload, "String");

  },
  async reportBackgroundEmail(payload) {
    var url = "api/Save_CustomerStatementDistributionEmail";
    return await ApiService.post(url, payload);
  },

  async getByRunId(RunId) {

    const requestScreenData = {
      url: "api/CustomerStatementRunList",
      top: "1",
      filter: `RunId eq ${RunId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  }
};

export { CustomerStatementService };
